<div class="collapse collapse-horizontal show h-100" id="friendsCollapse">
    <div class="d-flex flex-column text-light h-100"
        style="width: 275px; background-color: #111; border-left: 1px solid #333;">
        <div class="d-flex align-items-center p-3 border-bottom border-dark header-height">
            <h5 class="m-0" id="friendsCollapseLabel">Friends <small>({{onlineFriends().length}}/{{
                    filteredFriends().length }})</small></h5>
            <button type="button" class="btn btn-outline-secondary border-0 ms-auto" data-bs-toggle="collapse"
                data-bs-target="#friendsCollapse" aria-label="Close">
                <i class="bi bi-arrow-bar-right fs-5"></i>
            </button>
        </div>
        <div class="d-flex flex-column flex-grow-1 p-3 overflow-hidden">
            <div class="input-group mb-3">
                <span class="input-group-text bg-dark border-end-0 text-light" style="border-width: 2px!important;"><i
                        class="bi bi-search"></i></span>
                <input type="text" class="form-control border-start-0 bg-dark text-light"
                    placeholder="Search Friends..." [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)">
            </div>
            <ul class="list-unstyled flex-grow-1 overflow-auto m-0">
                @for(friend of filteredFriends(); track friend.userName) {
                <app-player-panel [player]="friend" [canDelete]="true"></app-player-panel>
                }
            </ul>
        </div>
    </div>
</div>